module.exports = __webpack_public_path__ + "media/images/icon__search--rb-white@2x-707f1f6056eadbb64405b47629f0d5fa.png";